var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Card",
    { staticClass: "i-content", attrs: { bordered: false, "dis-hover": "" } },
    [
      _c("div", { staticClass: "demo-split" }, [
        _c("div", { staticClass: "demo-split-left" }, [_vm._t("left")], 2),
        _c("div", { staticClass: "demo-split-right" }, [_vm._t("right")], 2),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }